import styled from 'styled-components';
import { maxMobile } from 'Utils/utilsStyle';

const Wrapper = styled.div`
  overflow: hidden;
  box-shadow: 0px 0px 24px rgb(0 0 0 / 10%);
  border-radius: 8px;
  text-align: left;
  padding-top: 20px;
  max-width: 100%;
  min-height: 78px;
  background-color: #fff;
  .skeleton-box{
    height:33px;
    width:250px;
    border-radius: 25px;
    margin-left:30px;
    @media all and (max-width: ${maxMobile}) {
      width: 32%;
    }
  }
`;

const FinancialStatsSkeleton = function FinancialStatsSkeleton() {
  return (
    <Wrapper>
      <span className="skeleton-box" />
    </Wrapper>
  );
};

export default FinancialStatsSkeleton;
